export const TABLE_ROW_HEIGHT = 85;
// Keep auto-row estimates aligned to the baseline row height to avoid pagination "jumps" when
// `getRowHeight={() => 'auto'}` rows are measured and their render zone is re-laid out.
export const TABLE_ROW_MEASURE_HEIGHT = TABLE_ROW_HEIGHT;
export const TABLE_PANEL_HEADER_HEIGHT = 48;
export const TABLE_GRID_HEADER_HEIGHT = 45;
export const TABLE_DIVIDER_WIDTH = 0.5;
